import { useEffect, useReducer } from 'react'

import { useDispatch } from 'react-redux'

import api from 'common/api'
import useScid from 'common/use-scid'
import { actions as snactions } from 'store/snackbar'

export const INITIAL_STATE = {
  error: false,
  loading: true,
  stateSummaries: [],
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return {
        ...state,
        error: false,
        loading: true,
      }
    case 'loaded': {
      const { data } = action
      return {
        ...state,
        error: false,
        loading: false,
        stateSummaries: data.states,
      }
    }
    case 'error': {
      return {
        ...state,
        error: true,
        loading: false,
      }
    }
  }
}

const useStateSummaries = () => {
  const scid = useScid()
  const [{ error, loading, stateSummaries }, dispatch] = useReducer(reducer, INITIAL_STATE)

  const snackDispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: 'loading' })
    api
      .get(`/api/colleges/${scid}/metrics/by-location`)
      .then((data) => dispatch({ type: 'loaded', data }))
      .catch(() => {
        dispatch({ type: 'error' })
        snackDispatch(snactions.addSnackbarItem('An error occurred while retrieving location metrics'))
      })
  }, [scid, snackDispatch])

  return {
    error,
    loading,
    stateSummaries,
  }
}

export default useStateSummaries
